import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { deleteEntry, toggleDelete } from 'entries/ducks';
import { isAtYourEntries } from 'entries/utils';
import DeleteModal from 'entries/components/delete_modal';

const mapStateToProps = (state, { routes }) => {
  const { deletingEntry } = state.entries;
  const user = state.user.profile_data;

  return {
    entry: deletingEntry,
    user
  };
}

const mapDispatchToProps = (dispatch, { location, routes }) => {
  return bindActionCreators({
    deleteEntry: partial(deleteEntry, location.query, isAtYourEntries({ routes })),
    toggle: partial(toggleDelete, null)
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal));



// WEBPACK FOOTER //
// ./entries/containers/delete_modal.js